"use client";

import { downloadICS, eventToICSData } from "@/src/lib/calendar";
import { createLogger } from "@jesus-central-church/logger";
import type { SbEvent } from "@storyblok/types/287435740670216/storyblok-components";
import { CalendarPlus } from "lucide-react";

const logger = createLogger("calendar");

interface AddToCalendarLinkProps {
  event: SbEvent;
  baseUrl: string;
  url?: string;
}

export default function AddToCalendarLink({
  event,
  baseUrl,
  url,
}: AddToCalendarLinkProps) {
  const handleAddToCalendar = () => {
    try {
      const icsData = eventToICSData(event, baseUrl, url);
      downloadICS(icsData);
    } catch (error) {
      logger.error("Failed to generate calendar event", { error, eventId: event._uid });
    }
  };

  return (
    <button
      onClick={handleAddToCalendar}
      className="bg-strategy-gold text-boldness hover:bg-strategy-gold/90 flex h-7 w-7 cursor-pointer items-center justify-center rounded-lg transition-all hover:scale-110 focus:outline-none focus:ring-2 focus:ring-strategy-gold focus:ring-offset-2"
      aria-label="Toevoegen aan kalender"
      title="Toevoegen aan kalender"
    >
      <CalendarPlus className="h-3.5 w-3.5" aria-hidden="true" />
    </button>
  );
}
